import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AboutMe from './AboutMe';
import './Download.css';
import './AboutMePage.css';

const LOGO = `${process.env.PUBLIC_URL}/on-screen-logo-white-bezel-h160.png`;

export default function AboutMePage() {
  const navigate = useNavigate();

  // Reuses Download.css's page-shell overrides (full-bleed dark background,
  // scrollbar theming) — same class Download.jsx toggles, since this page
  // shares that dark theme rather than having its own copy.
  useEffect(() => {
    document.body.classList.add('download-page-active');
    return () => document.body.classList.remove('download-page-active');
  }, []);

  return (
    <div className="download-page modern about-me-page">
      <nav className="dl-navbar">
        <div className="dl-navbar-inner">
          <img
            src={LOGO}
            alt="On-Screen"
            className="dl-navbar-logo"
            onClick={() => navigate('/about')}
          />
          <div className="dl-navbar-links">
            <button type="button" className="dl-navbar-link" onClick={() => navigate('/about')}>
              ← Back to On-Screen
            </button>
          </div>
        </div>
      </nav>

      <AboutMe />
    </div>
  );
}
